import React, { FC } from 'react';
import classNames from 'classnames';
import Svg from 'svg-inline-react';
import FrankLogoWhiteSvg from '@src/svgs/frank-logo-new.svg';
import FrankLogoBlackSvg from '@src/svgs/frank-logo-new-black.svg';
import { AiSuggestionButtonProps } from './props';
import './styles.scss';

export const AiSuggestionButton: FC<AiSuggestionButtonProps> = ({ className, isLoading, onRegenerateClick }) => {
  return (
    <div
      className={classNames('ai-suggestion-button', isLoading && 'ai-suggestion-button--loading', className)}
      onClick={onRegenerateClick}
    >
      <div className="ai-suggestion-button__background" />

      <div className={classNames('ai-suggestion-button__text', isLoading && 'ai-suggestion-button__text--loading')}>
        {isLoading ? 'Generating...' : 'Generate with AI'}
      </div>

      <Svg className="ai-suggestion-button__logo ai-suggestion-button__logo--inactive" src={FrankLogoWhiteSvg} />

      <Svg className="ai-suggestion-button__logo ai-suggestion-button__logo--active" src={FrankLogoBlackSvg} />
    </div>
  );
};
